import ImgOne from "../images/kitchen-1.jpg";
import ImgTwo from "../images/kitchen-2.jpg";
import ImgThree from "../images/kitchen-3.jpg";
import ImgFour from "../images/kitchen-4.jpg";
import ImgFive from "../images/kitchen-5.jpg";

export const sliderData = [
  {
    id: 1,
    title: "Save up to 70% - Door Crasher Deals",
    image: ImgOne,
    alt: "kitchen1",
  },
  {
    id: 2,
    title: "Get free gift with purchase of $75",
    image: ImgTwo,
    alt: "kitchen2",
  },
  { id: 3, title: "Buy one get one 50% off", image: ImgThree, alt: "kitchen3" },
  { id: 4, title: "Check out new flyer", image: ImgFour, alt: "kitchen4" },
  { id: 5, title: "See what's trending now", image: ImgFive, alt: "kitchen5" },
];
